import _ from 'underscore';

import SEGMENT_EVENTS from 'constants/segmentEvents';

function Ctrl($scope, imgix, loggerService, favoritesService, tracking) {
  if ($scope.placeholder) {
    return;
  }

  $scope.$watch('venue', function(venue) {
    if (!venue || !venue.tags) return;

    $scope.venue.type = _.find(venue.tags, function(tag) {
      return tag.key === 'VENUE_TYPE';
    });

    $scope.venue.subtype = _.find(venue.tags, function(tag) {
      return tag.key === 'VENUE_SUB_TYPE';
    });
  });

  $scope.isFavorited = false;
  $scope.disableFavoriting = true;

  if ($scope.venue && $scope.venue.id) {
    favoritesService.isFavorite(favoritesService.TYPES.VENUE, $scope.venue.id)
      .then(function(favorited) {
        $scope.isFavorited = favorited;
        $scope.disableFavoriting = false;
      }).catch(function(err) {
        loggerService.error(err);
      });
  }

  $scope.imgix = function(src) {
    const options = {
      width: 360,
      height: 280
    };

    try {
      return imgix.url(src, options);
    } catch (err) {
      return null;
    }
  };

  $scope.favoriteVenue = function(venue) {
    $scope.disableFavoriting = true;

    const func = ($scope.isFavorited) ? favoritesService.removeFavorite : favoritesService.addFavorite;
    const increment = ($scope.isFavorited) ? -1 : 1;

    func(favoritesService.TYPES.VENUE, venue.id)
      .then(() => {
        venue.favoriteCount += increment;
        $scope.isFavorited = !($scope.isFavorited);

        const event = ($scope.isFavorited) ? SEGMENT_EVENTS.FavoritedVenue : SEGMENT_EVENTS.UnfavoritedVenue;

        tracking.trackEvent(event, {
          venueId: $scope.venue.id,
          venueName: $scope.venue.name
        });
      })
      .catch(err => {
        loggerService.error(err);
      })
      .finally(() => {
        $scope.disableFavoriting = false;
      });
  };
}

Ctrl.$inject = [
  '$scope',
  'jsSdk.imgix',
  'loggerService',
  'favoritesService',
  'trackingService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/directives/venueCard/controller.js